<template>
  <v-dialog v-model="show" max-width="600px">
    <v-card>
      <v-card-title primary-title> แก้ไขวิดีโอ </v-card-title>
      <v-card-text class="d-flex justify-center">
        <video
          v-if="allowvideo && tempurl !== null"
          @error="allowvideo = !allowvideo"
          width="180"
          controls
          :src="tempurl"
        >
          Your browser does not support the video tag.
        </video>
        <div v-else>
          <img
            src="https://developers.google.com/maps/documentation/maps-static/images/error-image-generic.png?hl=es-419"
            width="150px"
          />
          <br />
          <p class="font-italic mb-1">* Content Expire</p>
        </div>
      </v-card-text>
      <v-card-text class="d-flex justify-center">
        <input
          ref="video"
          type="file"
          accept="video/*"
          @change="Video()"
          class="d-none"
        />
        <v-btn color="primary" outlined @click="$refs.video.click()"
          >เปลี่ยนวิดีโอ</v-btn
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="(show = false), (tempurl = message.url)"
          >ปิด</v-btn
        >
        <v-btn color="primary" outlined @click="ChangeVideo">ตกลง</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["visible", "message"],
  data() {
    return {
      allowvideo: true,
      tempurl: null,
    };
  },
  mounted() {
    this.tempurl = this.message.url;
  },
  watch: {
    message: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (oldValue && newValue) {
          if (oldValue.url !== newValue.url) {
            this.tempurl = newValue.url;
          }
        }
      },
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    ChangeVideo() {
      this.message.url = this.tempurl;
      this.show = false;
    },
    Video() {
      for (const key in this.$refs.video.files) {
        if (Object.hasOwnProperty.call(this.$refs.video.files, key)) {
          const element = this.$refs.video.files[key];
          if (
            /\.(ogm|wmv|mpg|webm|ogv|mov|asx|mpeg|mp4|m4v|avi)$/i.test(
              element.name
            )
          ) {
            let videomb = element.size / 1000000;
            if (videomb <= 25) {
              let formData = new FormData();
              formData.append("fileMax", 25);
              formData.append("fileData", element);
              formData.append(
                "filePath",
                `survey/video/${this.$route.params.surveyID}/question/`
              );
              formData.append("fileName", `${Date.now()}-`);
              this.$store.commit("ToggleLoading");
              this.$store
                .dispatch("UploadFormData", formData)
                .then((req) => {
                  this.tempurl = req.data;
                  this.$store.commit("ToggleLoading");
                })
                .catch(() => {
                  this.$store.commit("ToggleLoading");
                });
            } else {
              Swal.fire({
                icon: "error",
                title: "ขนาดวิดีโอเกินกว่าที่กำหนด",
                text: "กรุณา upload วิดีโอไม่เกิน 25 mb",
                showCancelButton: false,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                confirmButtonColor: "#0093cc",
                confirmButtonText: "ตกลง",
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่วิดีโอเท่านั้น",
              text: `รองรับ ogm, wmv, mpg, webm, ogv, mov, asx, mpeg, mp4, m4v, avi`,
              showCancelButton: false,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "ตกลง",
            }).then(() => {
              this.$refs.video.type = "text";
              this.$refs.video.type = "file";
            });
          }
        }
      }
      this.$refs.video.type = "text";
      this.$refs.video.type = "file";
    },
  },
};
</script>
